"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Action = void 0;
const Thing_1 = require("./Thing");
const Person_1 = require("./Person");
const models_1 = require("lincd/lib/models");
const package_1 = require("../package");
const schema_1 = require("../ontologies/schema");
const xsd_1 = require("lincd-xsd/lib/ontologies/xsd");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
const actionConstants = __importStar(require("../constants"));
const Place_1 = require("./Place");
const XSDDate_1 = require("lincd-xsd/lib/shapes/XSDDate");
const ShapeSet_1 = require("lincd/lib/collections/ShapeSet");
let Action = class Action extends Thing_1.Thing {
    /**
     * The status of an Action (enums).
     */
    get actionStatus() {
        return parseInt(this.getValue(schema_1.schema.actionStatus));
    }
    set actionStatus(val) {
        // if (val > 3) {
        //   throw Error('Invalid value, use Action.STATUS enums');
        // }
        this.overwrite(schema_1.schema.actionStatus, new models_1.Literal(val.toString(), xsd_1.xsd.integer));
    }
    get agent() {
        return this.getOneAs(schema_1.schema.agent, Person_1.Person);
    }
    set agent(val) {
        this.overwrite(schema_1.schema.agent, val ? val.node : null);
    }
    get participant() {
        return this.getOneAs(schema_1.schema.participant, Person_1.Person);
    }
    set participant(val) {
        this.overwrite(schema_1.schema.participant, val ? val.node : null);
    }
    get objects() {
        return this.getAllAs(schema_1.schema.object, Thing_1.Thing, true);
    }
    // set objects(objects: ShapeSet<Thing>) {
    //   objects.updateEach(schema.object, this.namedNode);
    // }
    // get object(): Thing {
    //   if (this.hasProperty(schema.object)) {
    //     return this.getOneAs(schema.object, Thing, true);
    //   } else {
    //     return null;
    //   }
    // }
    // set object(val: Thing) {
    //   this.overwrite(schema.object, val ? val.node : null);
    // }
    get location() {
        return this.getOneAs(schema_1.schema.location, Place_1.Place);
    }
    set location(val) {
        this.overwrite(schema_1.schema.location, val ? val.node : null);
    }
    get startTime() {
        return this.hasProperty(schema_1.schema.startTime)
            ? XSDDate_1.XSDDate.toNativeDate(this.getOne(schema_1.schema.startTime))
            : null;
    }
    set startTime(nativeDate) {
        this.overwrite(schema_1.schema.startTime, XSDDate_1.XSDDate.fromNativeDate(nativeDate).node);
    }
    get endTime() {
        return this.hasProperty(schema_1.schema.endTime)
            ? XSDDate_1.XSDDate.toNativeDate(this.getOne(schema_1.schema.endTime))
            : null;
    }
    set endTime(nativeDate) {
        this.overwrite(schema_1.schema.endTime, XSDDate_1.XSDDate.fromNativeDate(nativeDate).node);
    }
};
Action.targetClass = schema_1.schema.Action;
Action.STATUS_ACTIVE = actionConstants.STATUS_ACTIVE;
Action.STATUS_COMPLETED = actionConstants.STATUS_COMPLETED;
Action.STATUS_POTENTIAL = actionConstants.STATUS_POTENTIAL;
Action.STATUS_FAILED = actionConstants.STATUS_FAILED;
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.actionStatus,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], Action.prototype, "actionStatus", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: schema_1.schema.agent,
        shape: Person_1.Person,
        maxCount: 1,
    }),
    __metadata("design:type", Person_1.Person),
    __metadata("design:paramtypes", [Person_1.Person])
], Action.prototype, "agent", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: schema_1.schema.participant,
        shape: Person_1.Person,
        maxCount: 1,
    }),
    __metadata("design:type", Person_1.Person),
    __metadata("design:paramtypes", [Person_1.Person])
], Action.prototype, "participant", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: schema_1.schema.object,
        shape: Thing_1.Thing,
    }),
    __metadata("design:type", ShapeSet_1.ShapeSet),
    __metadata("design:paramtypes", [])
], Action.prototype, "objects", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: schema_1.schema.location,
        shape: Place_1.Place,
        maxCount: 1,
    }),
    __metadata("design:type", Place_1.Place),
    __metadata("design:paramtypes", [Place_1.Place])
], Action.prototype, "location", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.startDate,
        required: false,
        maxCount: 1,
    }),
    __metadata("design:type", Date),
    __metadata("design:paramtypes", [Date])
], Action.prototype, "startTime", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.endTime,
        required: false,
        maxCount: 1,
    }),
    __metadata("design:type", Date),
    __metadata("design:paramtypes", [Date])
], Action.prototype, "endTime", null);
Action = __decorate([
    package_1.linkedShape
], Action);
exports.Action = Action;
//# sourceMappingURL=Action.js.map